import { useQuery } from '@tanstack/react-query';
import { clientImageAssetsService } from '../services/clientImageAssetsService';

export const useClientImageAsset = (
  tenantId: string | null,
  id: string | null
) => {
  return useQuery({
    queryKey: ['clientImageAssets', 'detail', tenantId, id],
    queryFn: async () => {
      if (!tenantId || !id) return null;
      return clientImageAssetsService.getById(tenantId, id);
    },
    enabled: !!tenantId && !!id,
    staleTime: 60_000,
  });
};
